<template>
	<div
		class="hidden lg:flex dropdown absolute bottom-0 left-0 translate translate-y-full w-full z-50 flex-col gap-4 p-4 min-w-[200px] overflow-hidden bg-white shadow-lg border border-gray"
	>
		<NuxtLink
			v-for="child in blok.children"
			:key="child._uid"
			:to="getLink(child.link)"
			class="text-sm font-normal text-gray-super-dark hover:text-gray-dark"
			@click="$emit('close')"
		>
			{{ child.name }}
		</NuxtLink>
	</div>
</template>

<script setup lang="ts">
import type { BlokMenuItem } from "~/types/storyblok/storyblok";

interface Props {
	blok: BlokMenuItem;
	getLink: (link: BlokMenuItem["link"]) => string;
}

defineProps<Props>();
defineEmits(["close"]);
</script>
